import {
  jb_arrow_icon_css_default
} from "./chunk.34OLQLOA.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-arrow-icon/jb-arrow-icon.ts
var JbArrowIcon = class extends Icon(r) {
  constructor() {
    super(...arguments);
    this.direction = "right";
    this.disabled = false;
  }
  render() {
    return ke`
      <svg
        width="38"
        height="23"
        xmlns="http://www.w3.org/2000/svg"
        class="${Rt({ [this.direction]: true, disabled: this.disabled })}"
        viewBox="0 0 38 23"
      >
        <path
          d="M34.1 10L25.5 1.42 26.94 0l10 10H37v.06l1.08 1.08-1.42 1.42-10.24 10.23L25 21.37 34.37 12H0v-2h34.1z"
          fill-rule="evenodd"
        />
      </svg>
    `;
  }
};
JbArrowIcon.styles = [reset_css_default, jb_arrow_icon_css_default];
__decorateClass([
  n()
], JbArrowIcon.prototype, "direction", 2);
__decorateClass([
  n({ type: Boolean })
], JbArrowIcon.prototype, "disabled", 2);
JbArrowIcon = __decorateClass([
  customElement("jb-arrow-icon")
], JbArrowIcon);

export {
  JbArrowIcon
};
